'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//  ----------  CODE EXAMPLES  ----------------------------

var CodeTabPane = _react2['default'].createClass({
    displayName: 'CodeTabPane',


    propTypes: {
        languageName: _react2['default'].PropTypes.string.isRequired,
        codeStringLines: _react2['default'].PropTypes.array.isRequired,
        codeClassNames: _react2['default'].PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'codeClassNames': ''
        };
    },
    render: function render() {

        var classes = (0, _classnames2['default'])('m-code-example', this.props.languageName.replace(/\#|\./g, ''));
        var preClasses = (0, _classnames2['default'])('m-code-example--code', 'prettyprint', this.props.codeClassNames);

        return _react2['default'].createElement(
            'div',
            { className: classes },
            _react2['default'].createElement(
                'pre',
                { className: preClasses },
                this.props.codeStringLines.join('\n').replace(/\&quot\;/g, '"')
            )
        );
    }
});

module.exports = CodeTabPane;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/code-tab-pane.jsx
 ** module id = 868
 ** module chunks = 0
 **/